import { PagedResults } from "../types/generics";
import { LoginResponse, UpdateUserDTO, User } from "../types/User";
import { getEndpoint } from "../utils/stringUtil";
import client from "./axios";

const usersUrl = `${getEndpoint()}api/users`;
const newUsersUrl = `${getEndpoint()}api/v2/users`;
const userUrl = `${getEndpoint()}api/user`;

export const Users = {
  getUserInfo: () => client.get<{ user: User }>(newUsersUrl),
  login: (body: { username: string, password: string }) => client.post<LoginResponse>(`${userUrl}/login`, body),
  getUsers: (params?: URLSearchParams) => client.get<PagedResults<User> | { list: User[] }>(`${usersUrl}/list`, { params }),
  getUsersForProgrammazioni: (params?: URLSearchParams) => client.get<{ list: User[] }>(`${newUsersUrl}/list`, { params }),
  createUser: (body: Record<string, any>) => client.post<{ user: User }>(usersUrl, body),
  deleteUser: (id: number) => client.delete(`${newUsersUrl}/${id}`),
  getUser: (id: number) => client.get<{ user: User }>(`${userUrl}/${id}`),
  updateUser: (id: number, body: UpdateUserDTO) => client.put<{ modified: User }>(`${userUrl}/${id}`, body),
  reIssueTemporaryPassword: (id: number) => client.get<{ message: string }>(`${getEndpoint()}api/re-issue-temporary-password/${id}`),
  getUserByToken: (token: string) => client.get<{ user: User }>(`${getEndpoint()}api/verify/user`, { params: { id: token } }),
  getUserByTokenReIssue: (token: string) => client.get<{ user: User }>(`${getEndpoint()}api/verify/re-issue-password`, { params: { id: token } }),
  verifyUser: (body: { token: string; oldPassword: string; password: string; passwordConfirmation: string }) =>
    client.post<{ user: User }>(`${getEndpoint()}api/verify-user`, body),
  resetPassword: (body: { token: string; oldPassword: string; password: string; passwordConfirmation: string }) =>
    client.post<{ user: User }>(`${getEndpoint()}api/reset-password`, body),
};
